import theme from '../themes/default'

export default {
  wrap: {
    '& .am-stepper-input': {
      'pointer-events': 'none',
    },
    '& .am-activity-indicator': {
      background: '#fff',
      position: 'absolute',
      padding: '8px 5px',
      borderRadius: '5px',
      width: '42px',
      margin: '20% auto 0',
      left: '0',
      right: '0',
      'text-align': 'center',
    },
    '& .am-activity-indicator-spinner': {
      margin: '0 auto',
    },
    '& .am-icon': {
      'margin-top': '6px',
    },
    '& label': {
      'line-height': '70px !important',
      '&:before': {
        top: '22px !important',
        right: '26px !important',
      },
      '&:after': {
        top: '26px !important',
        right: '30px !important',
      },
    },
  },
  'bottom-sheet-option-list': {
    padding: '0',
    color: '#614D4A',
    'font-weight': 'bold',
    'font-size': '16px',
  },
  'activity-indicatior-wrap': {
    height: '100%',
    'text-align': 'center',
    'padding-top': '28%',
    '& span': {
      margin: '0 auto',
    },
  },
  'simulate-bottom-sheet-overlay': {
    height: '140px',
    position: 'relative',
  },
  'previous-arrow-image': {
    width: '30px',
    position: 'absolute',
    bottom: '0',
    left: '0',
    padding: '20px',
  },
  'bottom-sheet-container': {
    background: '#fff',
    'padding-top': '35px',
    height: window.innerHeight - 120 + 'px',
    'text-align': 'left',
    '& .scrollbar-track-y': {
      right: '-10px',
    },
    '& .scroll-content': {
      'padding-bottom': '180px',
    },
  },
  'bottom-sheet-title': {
    background: '#fff',
    'padding-bottom': '10px',
  },
  'title-left': {
    position: 'relative',
    color: '#614D4A',
    'font-weight': 'bold',
    'font-size': '18px',
    padding: '5px 0 5px 20px',
  },
  'title-left-background': {
    width: '40px',
    height: '10px',
    position: 'absolute',
    top: '22px',
    left: '0',
    background: '#ffe394',
    'border-top-right-radius': '15px',
    'border-bottom-right-radius': '15px',
  },
  'title-left-text': {

  },
  'title-right': {
    color: '#614D4A',
    height: '27px',
    padding: '10px 15px 5px 20px',
    'font-weight': 'bold',
    'text-align': 'right',
  },
  'title-right-price-prefix': {
    'margin-right': '3px',
    'vertical-align': 'middle',
    display: 'inline-block',
    height: '22px',
    'font-size': '13px',
  },
  'title-right-price': {
    'font-size': '20px !important',
    color: '#b30606 !important',
    display: 'inline-block',
  },
  'bottom-sheet-content': {
    padding: '15px',
    '& .am-checkbox-inner': {
      borderRadius: '0',
    },
    '& .am-button': {
      background: '#D5AD40',
      color: '#fff !important',
      'font-size': '16px !important',
      '&:before': {
        border: '0px !important',
      },
    },
  },
  'bottom-sheet-group': {
    'margin-bottom': '40px',
  },
  'waiter-bottom-sheet-group': {
    'margin-bottom': '40px',
    display: 'inline-block',
    width: '30%',
  },
  'bottom-sheet-group-title': {
    'margin-bottom': '5px',
    color: '#b30606',
    'font-size': '14px',
    'font-weight': 'bold',
    'line-height': 'initial',
  },
  'bottom-sheet-total-price-wrap': {
    flex: '0.4 !important',
  },
  'sold-out-text': {
    width: '80px',
    'text-align': 'center',
    color: 'red',
    'font-size': '16px',
  },
}



// WEBPACK FOOTER //
// ./src/assets/styles/components/Stepper.js